import { ACL } from '../constants.mjs';
import { getIriAll } from '../../thing/get.mjs';

//
/** @hidden */
function getModes(policy, type) {
    const modes = getIriAll(policy, type);
    return {
        read: modes.includes(ACL.Read),
        append: modes.includes(ACL.Append),
        write: modes.includes(ACL.Write),
        controlRead: false,
        controlWrite: false,
    };
}

export { getModes };
